export const LOCAL_STORAGE_KEY = {
  RPA_USER_ID: "RPA_USER_ID",
  RPA_TOKEN: "RPA_TOKEN",
  RPA_TOKEN_EXPIRE: "RPA_TOKEN_EXPIRE"
};

export const ROUTER_PATH={
    HOME:'/robot/myRobot',
    LOGIN:'/account/login',
    LOGIN_OUT:"/account/loginOut",
    ACCOUNT_INFO:'/account/accountInfo',
    ACCOUNT_RESET_PASSWORD:"/account/resetPassword",    
    ACCOUNT_FORGET_PASSWORD:"/account/forgetPassword",
    PROCESS_LIST:"/process/process",
    ROBOT_RUNNING_REPORT:"/robot/runningReport",
    ROBOT_MY_ROBOT:"/robot/myRobot",
    ROBOT_MONITOR:"/robot/monitor",
    PAY_REPORT:"/pay/payReport",
    ADMIN_USER:"/admin/listUser",
    ADD_USER:"/admin/addUser",
    UPDATE_USER:"/admin/updateUser",
    ADMIN_ROLE:"/admin/listRole",
    ADD_ROLE:"/admin/addRole"

}